import { Maybe } from "@jutro/types";
import { Accordion, Avatar } from "@jutro/ui";
import { envVars } from "envvars";
import { EdmMedicalPerson } from "lib/graphql/megaSchema";
import { avatarConfig } from "lib/tools/httpConfigs";
import { DeclarationForm } from "views/StaffSchedule/StaffSettings/components/StaffSettingsPanel/DeclarationForm";
import { StaffPreferencesForm } from "views/StaffSchedule/StaffSettings/components/StaffSettingsPanel/StaffPreferencesForm";
import { VisitsDurationForm } from "views/StaffSchedule/StaffSettings/components/StaffSettingsPanel/VisitsDurationForm";
import { getStaffGenreLabel } from "views/StaffSchedule/StaffSettings/tools";

type Props = {
  selectedStaff: Maybe<EdmMedicalPerson>;
};

export const StaffSettingsPanel = ({ selectedStaff }: Props) => {
  if (!selectedStaff) {
    return null;
  }

  return (
    <div
      className="border-jutro-new-warm-gray-200 flex grow flex-col gap-6 overflow-y-auto rounded-2xl border p-4"
      key={selectedStaff.id}
    >
      <div className="flex items-center gap-3">
        <Avatar
          type="photo"
          size="xl"
          imgSrc={`${avatarConfig[envVars.REACT_APP_CONFIG]}/${selectedStaff.id}`}
        />

        <div className="flex flex-col">
          <span className="font-heading-3">{selectedStaff.name}</span>
          <span className="font-paragraph-1">
            {getStaffGenreLabel(selectedStaff)}
          </span>
        </div>
      </div>

      <Accordion
        defaultOpen
        title="Długość trwania wizyty"
        content={<VisitsDurationForm selectedStaff={selectedStaff} />}
      />

      <Accordion
        defaultOpen
        title="Deklaracje"
        content={<DeclarationForm selectedStaff={selectedStaff} />}
      />

      <Accordion
        defaultOpen
        title="Obsługiwani pacjenci"
        content={<StaffPreferencesForm selectedStaff={selectedStaff} />}
      />
    </div>
  );
};
